import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import PropTypes from 'prop-types'

import AllCountries from '../all-countries'
import OnlineCategories from '../online-categories'
import AllCities from '../all-cities'

const UnderFooter = ({
  pageKeyword,
  startFullscreen,
  isFullScreenFiltersPage,
  isMobile,
  allCountries,
  onlineCategories,
  allCities,
  isCourseShowPage,
  isFullScreenMap
}) => {
  const isRequestTeacherPage = pageKeyword !== 'first-page'

  return (
    <LazyLoadComponent>
      <div
        id='under-footer'
        className='main-screen hide-on-booking'
        style={{
          display:
            isRequestTeacherPage || startFullscreen || isFullScreenFiltersPage || isFullScreenMap ? 'none' : 'block',
          height: isMobile ? 69 : 'unset'
        }}
      >
        {!isCourseShowPage && (
          <div className='hide-when-small w-100'>
            <AllCountries allCountries={allCountries} />
            {onlineCategories && onlineCategories.length > 0 && (
              <OnlineCategories onlineCategories={onlineCategories} />
            )}
            {allCities && allCities.length > 0 && <AllCities allCities={allCities} />}
          </div>
        )}
        <div className={`hide-when-big h-69${isCourseShowPage ? ' show-when-course-show-page-632-959' : ''}`} />
      </div>
    </LazyLoadComponent>
  )
}

UnderFooter.propTypes = {
  pageKeyword: PropTypes.string,
  startFullscreen: PropTypes.bool,
  isMobile: PropTypes.bool,
  isFullScreenFiltersPage: PropTypes.bool,
  allCountries: PropTypes.array,
  onlineCategories: PropTypes.array,
  allCities: PropTypes.array,
  isCourseShowPage: PropTypes.bool,
  isFullScreenMap: PropTypes.bool
}

export default UnderFooter
